
<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <template v-slot:activator="{ on }">
         <v-btn class="mnuEdit" fab 
          small
          :color="color"
          @click.stop.prevent="dialog = true"      
        >
          <v-icon dark style="color: white;">mdi-monitor</v-icon>
        </v-btn>
      </template>
      <form-desktop-mode
        v-if="dialog"
        :menu="dialog ? menu : null"
        :onCloseDesktopMode="handleCloseDesktopMode"
      />
    </v-dialog>
  </v-row>
</template>
<script>
  import {
    mapState
  } from 'vuex'
  import constants from '@/constants'
  import utils from '@/services/utils'
  import FormDesktopMode from './FormDesktopMode'

  export default {
    components: {
      FormDesktopMode
    },
    props: {
      color: {
        type: String,
        required: true
      },
      menu: {
        type: Object,
        required: true
      },
    },
    data () {
      return {
        dialog: false,
        notifications: false,
        sound: true,
        widgets: false,
      }
    },
    methods: {
      handleCloseDesktopMode () {
        this.dialog = false
      }
    }
  }
</script>
<style scoped>
  .v-content {
    /* background-color: blue; */
  }
  .v-btn--fab.v-size--small {
    width: 30px !important;
    height: 30px !important;
  }
  .v-btn--fab.v-size--small .v-icon {
    font-size: 18px !important;
  }
  .mnuEdit {
    margin-right: 10px;
  }
</style>
